import React from 'react';
import PlusIcon from '@heroicons/react/solid/PlusIcon.js';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import { T } from '@tribeplatform/react-components/i18n';
import { SpaceImage } from '@tribeplatform/react-components/Space';
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks';
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar';
export const CollectionMenuHeading = ({ collections, createSpace, canCreateSpace, }) => {
    const { matchPath } = useSpaceUtil();
    const location = useLocation();
    return (React.createElement(NavVertical, { className: "block-collection-menu" },
        React.createElement("div", { className: "space-y-2" }, collections.map(collection => {
            var _a, _b, _c;
            const hasSpaces = (_a = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _a === void 0 ? void 0 : _a.totalCount;
            if (!hasSpaces && !canCreateSpace) {
                return null;
            }
            return (React.createElement(NavVertical.Group, { key: collection.id },
                React.createElement(NavVertical.GroupHeader, null, collection.name),
                React.createElement(NavVertical.Group, { className: "pb-3" }, (_c = (_b = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 :
                    _c.map(({ node: space }) => {
                        var _a, _b;
                        const isSpaceActive = matchPath(space, location.pathname);
                        return (React.createElement(NavVertical.Item, { as: NavLink, key: space.id, to: (space === null || space === void 0 ? void 0 : space.relativeUrl) || '/', active: !!isSpaceActive },
                            React.createElement("div", { className: "me-3 -ms-1" },
                                React.createElement(SpaceImage, { space: space, size: "xs" })),
                            React.createElement("div", { className: "truncate flex-grow" }, space.name),
                            !!((_a = space === null || space === void 0 ? void 0 : space.authMemberProps) === null || _a === void 0 ? void 0 : _a.unreadPostsCount) && (React.createElement("span", { className: "text-xs rounded-md bg-background-pressed font-medium py-0.5 px-2 text-content-on-background-subdued" }, (_b = space === null || space === void 0 ? void 0 : space.authMemberProps) === null || _b === void 0 ? void 0 : _b.unreadPostsCount))));
                    }),
                    !hasSpaces ? (React.createElement(NavVertical.Item, { as: "button", onClick: () => {
                            createSpace({
                                collectionId: collection.id,
                            });
                        } },
                        React.createElement("div", { className: "w-6 h-6 -ms-1 me-3 flex justify-center items-center" },
                            React.createElement(PlusIcon, { className: "w-5 h-5" })),
                        React.createElement("div", { className: "truncate" },
                            React.createElement(T, { id: "Generics.AddSpace", defaultMessage: "Add {SPACE}" })))) : null)));
        }))));
};
//# sourceMappingURL=CollectionMenuHeading.js.map